export default "__VITE_ASSET__CVkT$uMM__"